/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
export default class AchievementCategory extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  image() {
    return Model.attribute('image').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
  order() {
    return Model.attribute('order').call(this);
  }
  achievements() {
    return Model.hasMany('achievements').call(this);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/AchievementCategory', AchievementCategory);